import React, {useContext} from 'react';
import Folder from "../folders/folders";
import FloContext from "../contexts/floContext";

import AddIconWhite from '../../assets/images/add-icon-white.svg';
import UserPic from '../../assets/images/user-pic.svg';

export default function Explorer(props: any) {

   const {filesAndFolders, onAddFolder}: any = useContext(FloContext);
   return (
       <div className="explorer">
          <div className="expander icon" onClick={props.onCollapse}>
             <img src={require('../../assets/images/expand-nav.png')} alt=""/>
          </div>
          <button className="btn item-height-35 create-flo-short-btn flex">
             <img src={AddIconWhite} alt=""/>
          </button>

          <div className="explorer-content">
             <div className="padding-lr-20">
                <div className="logo highlight-color font-22 rubik-medium margin-b-20">Floik</div>
                <button className="btn width-block round-corner-8 item-height-40 margin-b-30">
                   <div className="flex hr-center text-no-wrap text-overflow-hidden">
                      <div className="icon width-16">
                         <img src={AddIconWhite} alt=""/>
                      </div>
                      <div className="margin-l-5 font-14">Create new flo</div>
                   </div>
                </button>
             </div>
             <div className="folders-sec">
                <div className="inline-block margin-b-20 padding-lr-20 cursor-pointer" onClick={onAddFolder}>
                   <div className="inline-block rubik-medium margin-r-5 font-16">My folders</div>
                   <div className="inline-block icon width-17">
                      <img src={require('../../assets/images/add-icon-black.png')} alt=""/>
                   </div>
                </div>

                {/*...... folders ........*/}
                <ul className="folders font-14">
                   {
                      filesAndFolders.map((folder: any, index: number) => {
                         return (
                             <Folder key={folder._id} folder={folder}  index={index} />
                         )
                      })
                   }
                </ul>
             </div>
          </div>

          <div className="user-sec flex padding-lr-20 padding-t-10 cursor-pointer">
             <div className="user-icon icon width-30">
                <img src={UserPic} alt=""/>
             </div>
             <div className="user-name font-14 margin-l-10">Michael Scott</div>
          </div>
          
       </div>
   )
}
